/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DefaultFileExtensionIconIds } from '../models/default-file-extension-icon-ids';
@Injectable({
  providedIn: 'root',
})
class DefaultIconIdsService extends __BaseService {
  static readonly DefaultIconIdsGetFileExtensionsPath = '/default-icon-ids/file-extensions';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns all icon ids for each file extension
   * @param Authorization Bearer JSON Web Token
   * @return OK
   */
  DefaultIconIdsGetFileExtensionsResponse(Authorization: string): __Observable<__StrictHttpResponse<DefaultFileExtensionIconIds>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/default-icon-ids/file-extensions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DefaultFileExtensionIconIds>;
      })
    );
  }
  /**
   * Returns all icon ids for each file extension
   * @param Authorization Bearer JSON Web Token
   * @return OK
   */
  DefaultIconIdsGetFileExtensions(Authorization: string): __Observable<DefaultFileExtensionIconIds> {
    return this.DefaultIconIdsGetFileExtensionsResponse(Authorization).pipe(
      __map(_r => _r.body as DefaultFileExtensionIconIds)
    );
  }
}

namespace DefaultIconIdsService {
}

export { DefaultIconIdsService }